import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'

import './style.scss'
import { PlotlyWidget, SuspededReactPlotly } from './PlotlyWidget'
import { plotlyReducer } from './plotlyReducer'

Object.defineProperty(window, 'LivePlotly', {
    value: SuspededReactPlotly
})

widgetService.register({
    type: 'plotly-chart',
    name: 'Ploty Chart',
    description: 'Plotly Chart',
    config: {},
    policies: {
        defaultReducer: '@latest',
        layers: 5,
        legends: false,
        allowYAxisConfig: false,
        allowGroupedYAxis: false,
        allowHideTooltip: false
    },
    impl: reactWidgetWrapper(PlotlyWidget, plotlyReducer, {
        mapConfigToProps(cfg) {
            return {
                widget: cfg.widget,
                theme: cfg.dashboardContext.theme
            }
        }
    })
})
